import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { graphql } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import { Form, Row, Col, Button, Tag, Checkbox, message, Icon, Spin, Radio, Modal } from 'antd'
import moment from 'moment'
import _get from 'lodash/get'
import _sortBy from 'lodash/sortBy'
import _findKey from 'lodash/findKey'
import _flatten from 'lodash/flatten'
import _intersection from 'lodash/intersection'
// import queryString from 'query-string'

import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl'

import RegistrationSteps from '~/App/components/RegistrationSteps'
import registrationQuery from '~/App/graphql/queries/registration.gql'
import submitRegistrationMutation from '~/App/graphql/mutations/submitRegistration.gql'
import addOrderItemMutation from '~/App/graphql/mutations/addOrderItem.gql'
import removeOrderItemMutation from '~/App/graphql/mutations/removeOrderItem.gql'
import setRegistrationDeliveryOptionIdMutation from '~/App/graphql/mutations/setRegistrationDeliveryOptionId.gql'
import getAgeCategory from '~/App/utils/getAgeCategory'
import compare from '~/App/utils/compare'
import ParticipantEditModal from '~/App/components/ParticipantEditModal'
import ProductCrossSale from '~/App/components/ProductCrossSale'
import OrderItemModal from '~/App/components/OrderItemModal'
import DeliveryAddressModal from '~/App/components/DeliveryAddressModal'
import DeliveryAddressPreviewBox from '~/App/components/DeliveryAddressPreviewBox'
import OrderItemsCart from '~/App/components/OrderItemsCart'
import bibNumber from '~/App/utils/bibNumber'
import withUser from '~/App/hocs/withUser'
import localeGet from '~/App/utils/localeGet'

const RadioGroup = Radio.Group
// const getAgeCategory = ({
//   race: { startTime, ageCategories, ageCategoryDiff },
//   birthDate,
//   gender
// }) => {
//   // TODO: important use race
//   const $birthDate = moment(birthDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
//   const {
//     month, date, hour, minute, second, millisecond
//   } = $birthDate.toObject()
//   let $startTime = moment(startTime).set({
//     month, date, hour, minute, second, millisecond
//   })
//   if (ageCategoryDiff === 'day') {
//     $startTime = moment(startTime).set({
//       hour, minute, second, millisecond
//     })
//   }
//   const fullAge = $startTime.diff($birthDate, 'year') // moment(startTime).year() - moment(birthDate).year()
//   return {
//     category: ageCategories.filter(cat => cat.gender === gender).find(cat => {
//       return (
//         (!cat.min && cat.max >= fullAge) ||
//         (!cat.max && cat.min <= fullAge) ||
//         (cat.min <= fullAge && cat.max >= fullAge)
//       )
//     }),
//     gender
//   }
// }
const taxInvoiceOptions = [{
  _id: 'none',
  en: 'None',
  zh: 'None',
  th: 'ไม่ขอใบกำกับภาษี'
}, {
  _id: 'individual',
  en: 'Individual',
  zh: 'Individual',
  th: 'บุคคล'
}, {
  _id: 'company',
  en: 'Company',
  zh: 'Company',
  th: 'บริษัท'
}]
const receiptOptions = [{
  _id: 'none',
  en: 'None',
  zh: 'None',
  th: 'ไม่ขอใบเสร็จรับเงิน'
}, {
  _id: 'individual',
  en: 'Individual',
  zh: 'Individual',
  th: 'บุคคล'
}, {
  _id: 'company',
  en: 'Company',
  zh: 'Company',
  th: 'บริษัท'
}]

@inject('router')
@withUser()
@graphql(removeOrderItemMutation, {
  name: 'removeOrderItemMutation'
})
@graphql(registrationQuery, {
  options: ({ match: { params: { id } } }) => ({
    variables: { _id: id },
    fetchPolicy: 'network-only'
  })
})
@graphql(submitRegistrationMutation, {
  name: 'submitRegistration'
})
@graphql(addOrderItemMutation, {
  name: 'addOrderItem'
})
@graphql(setRegistrationDeliveryOptionIdMutation, {
  name: 'setRegistrationDeliveryOptionId'
})
@inject('i18n')
@injectIntl
@observer
class RegistrationPreview extends Component {
  state = {
    id: '',
    accepted: false,
    submitting: false,
    deliveryOptionId: null
  }

  alertError = (err) => {
    const { graphQLErrors } = err
    if (graphQLErrors) {
      graphQLErrors.forEach(error => {
        Modal.error({
          title: '',
          content: error.message
        })
      })
    } else {
      Modal.error({
        title: '',
        content: err.message
      })
    }
  }

  handleAccept = (e) => {
    this.setState({ accepted: e.target.checked })
  }

  handleRemoveOrderItem = ({_id}) => {
    this.setState({submitting: true})
    const {history, removeOrderItemMutation, data: { registration }} = this.props
    removeOrderItemMutation({
      variables: { _id }
    }).then(res => {
      history.push(`/reg/${registration._id}/preview`)
    }).catch(e => {
      this.alertError(e)
      this.submitting = false
    })
  }

  ageCategoryString = ({ category, gender }) => {
    const g = gender ? gender[0].toUpperCase() : ''
    if (!category) {
      return <FormattedMessage id="app.ageCategories.open" />
    }
    const { min, max } = category
    if (!min && max) {
      return <FormattedMessage id="app.ageCategories.under" values={{ gender: g, upper: max + 1 }} />
      // return `${g} under ${max + 1}`
    } else if (min && !max) {
      return <FormattedMessage id="app.ageCategories.over" values={{ gender: g, lower: min }} />
      // return `${g} ${min} up`
    } else {
      return <FormattedMessage id="app.ageCategories.between" values={{ gender: g, lower: min, upper: max }} />
      // return `${g} ${min} - ${max}`
    }
  }
  handleSetRegistrationDeliveryOptionId = async ({rid, deliveryOptionId}) => {
    const {setRegistrationDeliveryOptionId} = this.props
    this.setState({
      submitting: true
    })
    await setRegistrationDeliveryOptionId({
      variables: {
        _id: rid,
        deliveryOptionId: deliveryOptionId
      },
      refetchQueries: [{
        query: registrationQuery,
        variables: {
          _id: rid
        }
      }]
    }).then(res => {
      this.setState({
        submitting: false
      })
    }).catch(e => {
      console.error(e)
      Modal.error({
        title: '',
        content: e.message
      })
      this.setState({
        submitting: false
      })
    })
  }
  handleChangeDeliveryOptions = async e => {
    e.preventDefault()
    const { match: { params: { id } } } = this.props
    const deliveryOptionId = e.target.value
    this.setState({deliveryOptionId: deliveryOptionId})
    await this.handleSetRegistrationDeliveryOptionId({rid: id, deliveryOptionId: deliveryOptionId})
  }
  handleSubmitRegistration = async e => {
    e.preventDefault()
    const errors = []
    const { data, intl, submitRegistration, history, match: { params: { id } }, i18n: { locale } } = this.props
    const participants = _get(data, 'registration.participants')
    const deliveryAddress = _get(data, 'registration.deliveryAddress')
    const registrationType = _get(data, 'registration.registrationType')
    const minParticipants = _get(registrationType, 'minParticipants', 1) || 1
    const maxParticipants = _get(registrationType, 'maxParticipants')
    const restrictions = _get(registrationType, 'restrictions', [])
    const deliveryOptions = _get(registrationType, 'deliveryOptions.length') > 0 ? _get(registrationType, 'deliveryOptions').filter(d => !d.hidden) : 0
    const deliverOneAddressEnabled = _get(deliveryOptions, 'length') > 0
    const selectedDeliveryOption = deliverOneAddressEnabled ? _get(registrationType, 'deliveryOptions', []).find(o => o._id === this.state.deliveryOptionId) : null
    const requiredTicketTypeIds = _get(registrationType, 'requiredTicketTypeIds', [])
    const ticketTypes = _get(data, 'registration.event.ticketTypes', [])
    const requiredTicketTypes = ticketTypes.filter(tt => requiredTicketTypeIds.includes(tt._id))
    // const {
    //   submitRegistration,
    //   history,
    //   match: { params: { id } }
    // } = this.props
    // history.push(`/reg/${id}/preview`)
    // validateFields({ force: true }, (err, record) => {
    // if (!err) {

    const tickets = _flatten(participants.map(p => p.tickets))
    const selectedTicketTypeIds = tickets.map(t => t.productTypeId)
    const selectedTicketTypes = ticketTypes.filter(tt => selectedTicketTypeIds.includes(tt._id))
    selectedTicketTypes.forEach(ticketType => {
      const ticketRequiredTicketTypes = _get(ticketType, 'settings.requirements.ticketTypes', []) || []
      ticketRequiredTicketTypes.forEach(ticketTypeRequirement => {
        const { ticketTypeIds = [], count, ratio } = ticketTypeRequirement
        const requiredTicketTypes = ticketTypes.filter(tt => ticketTypeIds.includes(tt._id))
        const ticketTypeCount = tickets.filter(t => t.productTypeId === ticketType._id).length
        const requiredTypeCount = tickets.filter(t => ticketTypeIds.includes(t.productTypeId)).length
        const typeRatio = requiredTypeCount / ticketTypeCount
        // console.log({ ticketTypeCount, requiredTypeCount, typeRatio })
        const ticketTypeNames = requiredTicketTypes.map(tt => localeGet(tt, 'name', locale)).join(', ')
        let $message
        if (count) {
          if (count.minimum && requiredTypeCount < count.minimum) {
            $message = intl.formatMessage({
              id: 'app.minimumRequiredTicketTypeError',
              defaultMessage: 'Requires TicketType'
            }, {
              ticketTypes: ticketTypeNames,
              count: count.minimum
            })
          }
          if (count.maximum && requiredTypeCount > count.maximum) {
            $message = intl.formatMessage({
              id: 'app.maximumAllowedTicketTypeError',
              defaultMessage: 'Allowed TicketType'
            }, {
              ticketTypes: ticketTypeNames,
              count: count.maximum
            })
          }
        }
        if (ratio) {
          if (ratio.minimum && typeRatio < ratio.minimum) {
            const requiredCount = Math.ceil(ratio.minimum * ticketTypeCount)
            $message = intl.formatMessage({
              id: 'app.minimumRequiredTicketTypeError',
              defaultMessage: 'Requires TicketType'
            }, {
              ticketTypes: ticketTypeNames,
              count: requiredCount
            })
          }
          if (ratio.maximum && typeRatio > ratio.maximum) {
            const requiredCount = Math.ceil(ratio.maximum * ticketTypeCount)
            $message = intl.formatMessage({
              id: 'app.maximumAllowedTicketTypeError',
              defaultMessage: 'Allowed TicketType'
            }, {
              ticketTypes: ticketTypeNames,
              count: requiredCount
            })
          }
        }
        if ($message) {
          errors.push($message)
        }
      })
    })


    if (participants.length < minParticipants) {
      const $message = intl.formatMessage({
        id: 'app.minParticipantsNotice',
        defaultMessage: 'Please add more participant'
      }, {
        min: minParticipants
      })
      history.push(`/reg/${id}/edit?pId=new`)
      return message.warning($message)
    } else if (maxParticipants && participants.length > maxParticipants) {
      const $message = intl.formatMessage({
        id: 'app.maxParticipantsNotice',
        defaultMessage: 'Only {max} participants allowed'
      }, {
        max: maxParticipants
      })
      history.push(`/reg/${id}/edit?pId=new`)
      return message.warning($message)
    } else if (deliverOneAddressEnabled && selectedDeliveryOption.enabled && !deliveryAddress) {
      const $message = intl.formatMessage({
        id: 'app.deliveryAddressRequiredError',
        defaultMessage: 'Please add delivery address'
      })
      return message.warning($message)
    } else {
      const genders = participants.map(p => _get(p, 'profile.gender'))
      if (restrictions.includes('gender_mix') &&
        (!genders.includes('male') || !genders.includes('female'))
      ) {
        const $message = intl.formatMessage({
          id: 'app.genderMixError',
          defaultMessage: 'Group should contain both male and female participants'
        })
        return message.warning($message)
      } else if (restrictions.includes('gender_male') && genders.includes('female')) {
        const $message = intl.formatMessage({
          id: 'app.genderMaleOnlyError',
          defaultMessage: 'Only male participants allowed'
        })
        return message.warning($message)
      } else if (restrictions.includes('gender_female') && genders.includes('male')) {
        const $message = intl.formatMessage({
          id: 'app.genderFemaleOnlyError',
          defaultMessage: 'Only female participants allowed'
        })
        return message.warning($message)
      }
      if (requiredTicketTypeIds.length > 0) {
        const ticketTypeIds = _flatten(participants.map(p => _get(p, 'tickets'))).map(t => _get(t, 'ticketType._id'))
        const intersection = _intersection(requiredTicketTypeIds, ticketTypeIds)
        if (registrationType.requiredTicketTypeMode === 'any') {
          if (intersection.length === 0) {
            // const $message = intl.formatMessage({
            //   id: 'app.participantEmailUnique',
            //   defaultMessage: 'Each participant should have unique email'
            // })
            return message.warning(intl.formatMessage({
              id: 'app.requireAnyTickets',
              defaultMessage: 'Registration should include any of the following {ticketTypes}'
            }, {
                ticketTypes: requiredTicketTypes.map(tt => localeGet(tt, 'name', locale)).join(', ')
              }))
          }
        } else if (registrationType.requiredTicketTypeMode === 'all') {
          if (intersection.length !== requiredTicketTypeIds.length) {
            return message.warning(intl.formatMessage({
              id: 'app.requireAllTickets',
              defaultMessage: 'Registration should include all of the following {ticketTypes}'
            }, {
                ticketTypes: requiredTicketTypes.map(tt => localeGet(tt, 'name', locale)).join(', ')
              }))
          }
        }
      }
    }
    if (errors.length > 0) {
      return errors.forEach(error => Modal.warning({
        title: '',
        content: error
      }))
    }
    this.setState({
      submitting: true
    })
    if (deliverOneAddressEnabled) {
      await this.handleSetRegistrationDeliveryOptionId({rid: id, deliveryOptionId: this.state.deliveryOptionId})
    }
    this.setState({
      submitting: true
    })

    await submitRegistration({
      variables: {
        _id: id
      }
    }).then(res => history.push(`/reg/${id}/pay`), err => {
      console.log('REDIRECTING')
      const [{ message: $message }] = err.graphQLErrors
      console.error(err)
      Modal.error({
        title: '',
        content: $message
      })
      this.setState({
        submitting: false
      })
    }) // TODO: read from res.record?
    // }
    // })
  }
  async UNSAFE_componentWillReceiveProps (nextProps) { // eslint-disable-line
    const { currentUser, currentUserLoading, data, match: { params: { id } } } = nextProps
    const registration = _get(data, 'registration')
    if (!currentUserLoading && currentUser && registration && currentUser._id !== registration.userId) {
      this.props.history.replace(`/dashboard`)
    }
    const status = _get(data, 'registration.status')
    const registrationType = _get(data, 'registration.registrationType')
    const deliveryOptions = _get(registrationType, 'deliveryOptions.length') > 0 ? _get(registrationType, 'deliveryOptions').filter(d => !d.hidden) : 0
    const deliverOneAddressEnabled = _get(deliveryOptions, 'length') > 0
    let deliveryOptionId = _get(data, 'registration.deliveryOptionId')
    if (deliverOneAddressEnabled && !this.state.deliveryOptionId) {
      if (!_findKey(deliveryOptions, d => d._id === deliveryOptionId)) {
        deliveryOptionId = deliveryOptions[0]._id
      } else {
        deliveryOptionId = !deliveryOptionId ? deliveryOptions[0]._id : deliveryOptionId
      }
      this.setState({ deliveryOptionId: deliveryOptionId })
      if (registration.status === 'draft') {
        await this.handleSetRegistrationDeliveryOptionId({ rid: id, deliveryOptionId: deliveryOptionId })
      }
    }
    // const event = _get(registration, 'event')
    // const expired = _get(registration, 'expired')
    // const periods = _get(event, 'periods', [])
    // // const preRegisterPeriod = _get(event, 'preRegisterPeriod')
    // const currentPeriod = periods.find(period =>
    //   moment().isBetween(period.start, period.end)
    // )
    // const preRegisterOpen = currentPeriod && currentPeriod.preRegister
    if (['paid', 'payment_verifying'].includes(status)) {
      this.props.history.replace(`/reg/${id}`)
    }
  }
  handleSelectProduct = () => {
    const { location } = this.props.router
    location.query = {
      ...location.query,
      pdId: 'select'
    }
  }
  handleSelectDeliveryAddress = () => {
    const { location } = this.props.router
    location.query = {
      ...location.query,
      dAddr: 'select'
    }
  }
  handleAddOrderItem = async (orderItem) => {
    const { match: { params: { id } } } = this.props
    const { location } = this.props.router
    await this.props.addOrderItem({
      variables: {
        record: orderItem
      },
      // TODO: writeQuery
      refetchQueries: [{ // can use updateQuery
        query: registrationQuery,
        variables: {
          _id: id
        }
      }]
    })
    location.query = {
      ...location.query,
      pdId: 'select'
    }
  }
  render () {
    // console.log('render')
    const { data, match: { params: { id } }, i18n: { locale } } = this.props
    const { pId, pdId, dAddr, dAddrId } = this.props.router.location.query
    const editingParticipant = !!pId
    const selectDAddrVisible = dAddr === 'select'
    const { registration, loading, error } = data
    const deliveryAddress = _get(registration, 'deliveryAddress')
    const acceptCondition = _get(registration, 'event.settings.registration.acceptCondition')
    // const { l: locale = 'en' } = queryString.parse(search)
    // console.log(locale)
    if (loading || this.state.submitting) {
      return <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>
    }
    if (error) {
      console.error(error)
    }
    if (!registration) {
      return <div>Registration not found</div>
    }

    const ticketCount = registration.participants.reduce((count, participant) =>
      count + participant.tickets.length
      , 0
    )
    const {
      _id,
      expireAt,
      expired,
      event,
      participants,
      amount,
      itemsAmount,
      status,
      code,
      registrationType,
      couponCodes
    } = registration
    const hideNumber = _get(event, 'settings.ticket.hideNumber')
    const systemFee = _get(event, 'settings.registration.fee', 0)
    // const isSoldOut = _get(event, 'isSoldOut')
    const minParticipants = _get(registrationType, 'minParticipants', 1) || 1
    const maxParticipants = _get(registrationType, 'maxParticipants')
    const lottoEnabled = _get(registrationType, 'lotto.enabled') || false
    const lottoMessage = _get(registrationType, 'lotto.customMessage')
    const regIncomplete = (participants.length < minParticipants || (maxParticipants && participants.length > maxParticipants))
    const $regIncompleteNotice = <div>
      <FormattedMessage id="app.notice.incompleteReg" defaultMessage="Registration incomplete, please edit and add participants" values={{ minParticipants }} />
    </div>
    const deliveryOptions = _get(registrationType, 'deliveryOptions.length') > 0 ? _get(registrationType, 'deliveryOptions').filter(d => !d.hidden) : 0
    const deliverOneAddressEnabled = _get(deliveryOptions, 'length') > 0
    const selectedDeliveryOption = deliverOneAddressEnabled ? _get(registrationType, 'deliveryOptions', []).find(o => o._id === this.state.deliveryOptionId) : null
    const conditionAccepted = !acceptCondition || !acceptCondition.enabled || (acceptCondition && acceptCondition.enabled && this.state.accepted)
    const submitDisabled = regIncomplete || !conditionAccepted || (deliverOneAddressEnabled && _get(selectedDeliveryOption, 'enabled') && !registration.deliveryAddress)
    
    // successfulPayment
    // console.log({ couponCodes })
    const { periods = [], isRegOpen } = event
    const currentPeriod = periods.find(period =>
      moment().isBetween(period.start, period.end) || moment().isBetween(period.preRegisterStart, period.preRegisterEnd)
    )
    // const registerPeriod = periods.find(p => !p.preRegister)
    const isPreRegister = currentPeriod && moment().isBetween(currentPeriod.preRegisterStart, currentPeriod.preRegisterEnd)
    // const canPay = isRegOpen && currentPeriod && !currentPeriod.preRegister
    // const canSubmit = isRegOpen && currentPeriod && !currentPeriod.preRegister // || (preRegisterPeriod && moment().isBetween(preRegisterPeriod.start, preRegisterPeriod.end))
    const ticketsQuota = _get(event, 'ticketsQuota', [])

    const quota = ticketsQuota.find(q => q._id === registrationType.limitId)
    // console.log({ quota })
    const regTypeFull = (!!quota && quota.count >= quota.limit)
    // const $submitButton = (
    //   <Button
    //     type="primary"
    //     size="large"
    //     onClick={() => this.handleSubmit({ registrationId: _id })}
    //     style={{ marginLeft: '18px', float: 'right' }}
    //   >
    //     Submit
    //   </Button>
    // )
    // const $submitDisabledButton = (
    //   <Button
    //     type="primary"
    //     size="large"
    //     disabled
    //     style={{ marginLeft: '18px', float: 'right' }}
    //   >
    //     Submit
    //   </Button>
    // )
    // const $payButton = (
    //   <Link
    //     to={`/reg/${_id}/pay`}
    //     style={{ marginLeft: '18px', float: 'right' }}
    //   >
    //     <Button type="primary" size="large">
    //       PAY
    //     </Button>
    //   </Link>
    // )

    // const $expiredTag = <Tag color="red">Expired</Tag>
    // if (false) {
    //   const $actionButton = {
    //     draft: canSubmit ? $submitButton : $submitDisabledButton,
    //     submitted: canPay && (expired ? $expiredTag : $payButton)
    //   }
    //   console.log($actionButton)
    // }
    // console.log({ isPreRegister})
    // console.log({ submitDisabled, status, isRegOpen, regTypeFull })
    const $paymentStatus = ({
      paid: <Tag color="green" className="status">{_get(amount, 'discounted')} THB ({
        <FormattedMessage id="paymentStatus.paid" defaultMessage="Paid" />
      })</Tag>,
      payment_verifying: (
        <Tag color="yellow" className="status">{_get(amount, 'discounted')} THB ({
          <FormattedMessage id="paymentStatus.verifying" defaultMessage="Pending Verification" />
        })</Tag>
      ),
      '': <Tag color="orange" className="status">{_get(amount, 'discounted')} THB ({
        <FormattedMessage id="paymentStatus.pending" defaultMessage="Pending Payment" />
      })</Tag>
    })[status || '']
    const $nextAction = ({
      submitted: <div>
        <Link to={`/reg/${_id}/pay`}>
          <Button type="primary" disabled={expireAt && expired} ><FormattedMessage id="app.pay" defaultMessage="Pay" /></Button>
        </Link>
      </div>,
      draft: (isRegOpen
        ? (regTypeFull
          ? <Button type="danger" disabled>
            <FormattedMessage id="app.regTypeFull" defaultMessage="Registration Type Full" />
          </Button>
          : <div>
            {amount.discounted > 0
              ? <FormattedMessage id="app.reviewWarning" defaultMessage="Please your details before proceeding with payment." />
              : <FormattedMessage id="app.reviewSubmissionWarning" defaultMessage="Please your details before proceeding with submission." />
            }
            {' '}
            <Button type="primary" htmlType="submit" loading={this.state.submitting} disabled={submitDisabled}>
              <FormattedMessage id={amount.discounted > 0 ? 'app.pay' : 'app.submit'} defaultMessage="Submit" />
            </Button>
          </div>
        )
        : (isPreRegister
          ? <Button disabled>
            <FormattedMessage id={amount.discounted > 0 ? 'app.pay' : 'app.submit'} defaultMessage="Submit" disabled={true} />
          </Button>
          : <Button disabled><FormattedMessage id="app.regClosed" defaultMessage="Registration Closed" /></Button>
        )
      ),
      accepted: <React.Fragment>
        <div style={{ whiteSpace: 'pre-line', display: 'inline-block', verticalAlign: 'middle', textAlign: 'left' }}>{localeGet(registrationType, `lotto.${status}.message`, locale)}</div>
        <Link to={`/reg/${_id}/pay`}>
          <Button type="primary" style={{ marginLeft: '6px' }} disabled={expireAt && expired} ><FormattedMessage id="app.pay" defaultMessage="Pay" /></Button>
        </Link>
      </React.Fragment>,
      rejected: <React.Fragment>
        <div style={{ whiteSpace: 'pre-line', display: 'inline-block', verticalAlign: 'middle', textAlign: 'left' }}>{localeGet(registrationType, `lotto.${status}.message`, locale)}}</div>
        <Link to={`/dashboard`}>
          <Button type="primary" style={{ marginLeft: '6px' }} ><FormattedMessage id="app.myRegistrations" defaultMessage="Dashboard" /></Button>
        </Link>
      </React.Fragment>

    })[status]
    const { discounted, discount, total, deliveryPrice } = amount
    const discountedItemsAmount = _get(itemsAmount, 'discounted', 0)
    const TestMode = (event.testMode && <div className="testMode">
    <Tag color="red">
      Test mode !!!
    </Tag>
  </div>)
    if (regTypeFull) {
    // if (regTypeFull || isSoldOut) {
      return (<div className="EventRegisterPage">
        {TestMode}
        <div className="innerEventRegisterPage" >
          <div className="dividedBox">
            <div className="registrationTopTitle">
              {localeGet(event, 'name', locale)}
            </div>
            <div style={{textAlign: 'center'}}>
              <Tag color="red" style={{fontSize: '19px'}}>
                <FormattedMessage id="app.regTypeFull" defaultMessage="Registration Type Full" />
              </Tag>
            </div>
          </div>
        </div>
      </div>)
    }
    return <div className="EventRegisterPage">
      {TestMode}
      <div className="innerEventRegisterPage" >
        <div className="dividedBox">
          <div className="registrationTopTitle">
            {localeGet(event, 'name', locale)}
          </div>
          <RegistrationSteps step="review" />
        </div>
        <Form onSubmit={this.handleSubmitRegistration} >
          <div style={{ maxWidth: '1000px', margin: 'auto' }}>
            <div>
              {deliverOneAddressEnabled && <div className="deliverOptionsWrapper dividedBox">
                <h1>
                  { `${_get(deliveryOptions, 'length') > 1 ? 'เลือกรูปแบบการจัดส่ง' : 'รูปแบบการจัดส่ง'}` }
                </h1>
                <RadioGroup
                  onChange={this.handleChangeDeliveryOptions}
                  value={this.state.deliveryOptionId}
                  className="animationTempoHighlighting radioGroupBtn">
                  {deliveryOptions.map(({_id, name}) => {
                    return <Radio key={_id} value={_id}>
                      {localeGet(name, '', locale)}
                    </Radio>
                  })}
                </RadioGroup>
              </div>}
              {deliverOneAddressEnabled && _get(selectedDeliveryOption, 'enabled') && <div className="deliveryAddressPreviewBoxWrapper dividedBox">
                {deliveryAddress && <DeliveryAddressPreviewBox
                  editabled={true}
                  handleSelectDeliveryAddress={this.handleSelectDeliveryAddress}
                  deliveryAddress={deliveryAddress} locale={locale}
                  customMessage={_get(selectedDeliveryOption, `customMessage[${locale}]`, '')} />}
                {!deliveryAddress && <div className="alignCenter">
                  <Link to={`/reg/${registration._id}/preview?dAddr=select&dAddrId=new`} key="addDeliveryAddress">
                    <Button icon="file-add" className="create animationHighlighting">
                      <FormattedMessage id="app.fillDeliveryAddress" />
                    </Button>
                  </Link>
                </div>}
              </div>}
              <Row className="dividedBox">
                <Col xs={24}>
                  <span>
                    {code
                      ? <h1>{{
                        en: 'Reg. No.',
                        zh: 'Reg. No.',
                        th: 'ใบสมัคร'
                      }[locale]}: {code}</h1>
                      : <span>
                        {regIncomplete && <Tag color="orange" className="status">
                          {$regIncompleteNotice}
                        </Tag>}
                      </span>
                    }
                  </span>
                </Col>
                <Col xs={24}>
                  <div>
                    <FormattedMessage id="app.race_day" defaultMessag="Race Day" /> : {moment(event.startDate).format('Do MMMM YYYY')} {event.endDate && `- ${moment(event.endDate).format('Do MMMM YYYY')}`}
                    <br/>
                    {' '}
                    {$paymentStatus}
                    {' '}
                    {expireAt && !regIncomplete && ['draft', 'accepted'].includes(status) &&
                      (expired
                        ? <Tag color="red" className="status">
                          <FormattedMessage id="app.expired" defaultMessage="Expired" />
                        </Tag>
                        : <Tag color="orange" className="status">
                          <FormattedMessage id="app.payBeforeDate" defaultMessage="Please pay before {date}" values={{
                            date: moment(expireAt).format('Do MMMM HH:mm')
                          }}/>
                        </Tag>
                      )
                    }
                    {!regIncomplete && (lottoEnabled ? ({
                      draft: <Tag color="orange" className="status">
                        {{
                          en: 'submitted (pending lotto result)',
                          zh: 'submitted (pending lotto result)',
                          th: 'ส่งใบสมัครสำเร็จ (รอประกาศผลการสุ่มเลือก)'
                        }[locale]}
                      </Tag>,
                      accepted: <Tag color="orange" className="status">
                        {{
                          en: 'accepted',
                          zh: 'accepted',
                          th: 'ได้สิทธิ์ (accepted)'
                        }[locale]}
                      </Tag>,
                      rejected: <Tag color="orange" className="status">
                        {{
                          en: 'rejected',
                          zh: 'rejected',
                          th: 'ไม่ได้สิทธิ์ (rejected)'
                        }[locale]}
                      </Tag>
                    }[status])
                      : regTypeFull ? <span style={{ fontSize: '24px' }}><FormattedMessage id="app.regTypeFull" defaultMessage="Registration Type Full" /></span> : <Tag color="orange" className="status">
                        {amount.discounted > 0 ? 'การสมัครยังไม่สำเร็จ (ปุ่มชำระเงินอยู่ด้านล่าง)' : 'การสมัครยังไม่สำเร็จ กรุณากดส่งใบสมัคร'}
                      </Tag>
                    )}
                  </div>
                </Col>
                {/* <Col xs={2}> {$actionButton[status] }</Col> */}
                <Col xs={24}>
                  <div>
                    {participants.map(participant => {
                      const taxInvoiceChoiceEnabled = (_get(event, 'settings.participant.fields', []) || []).find(f => f.name === 'taxInvoice' && f.enabled)
                      const taxInvoiceTypeId = _get(participant, 'profile.taxInvoice.type')
                      const taxInvoiceType = taxInvoiceOptions.find(o => o._id === taxInvoiceTypeId)
                      const receiptChoiceEnabled = (_get(event, 'settings.participant.fields', []) || []).find(f => f.name === 'receipt' && f.enabled)
                      const receiptTypeId = _get(participant, 'profile.receipt.type')
                      const receiptType = receiptOptions.find(o => o._id === receiptTypeId)
                      const emergencyContact = _get(participant, 'profile.emergencyContact')
                      return <Row className="registrationPreviewDetailBox"
                        key={participant._id}
                      >
                        <Col span={24}>
                          <div className="code-box-title">
                            {`${({
                              en: 'Participant #',
                              zh: 'Participant #',
                              th: 'ผู้สมัครคนที่ '
                            })[locale]}${participant.order + 1}`}
                            {status === 'draft' && <Link to={`/reg/${id}/preview?pId=${participant._id}`}>
                              <Button icon="edit" className="edit" style={{margin: '0 0 3px 8px'}}>
                                <FormattedMessage id="app.edit" defaultMessage="Edit" />
                              </Button>
                            </Link>}
                          </div>
                        </Col>
                        <Col xs={23} sm={11}>
                          {participant.profile.imageUrl && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {
                                {
                                  en: 'Straight face photo',
                                  zh: 'Straight face photo',
                                  th: 'ภาพถ่ายหน้าตรง'
                                }[locale]
                              }
                            </span>
                            <span className="eventBottomDetailData">
                              <img src={participant.profile.imageUrl} alt="identification" style={{ maxWidth: 100 }}/>
                              {_get(participant, 'profile.imageValidation.errors', []).map(error =>
                                <div key={error} style={{ color: 'orange' }}><FormattedMessage id={`api.faceValidate.${error}`} /></div>
                                // intl.formatMessage({ id: `api.faceValidate.${error}` })
                              )}
                            </span>
                          </div>}
                          <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {participant.profile.firstName}{' '}
                              {participant.profile.lastName}{' '}
                            </span><br/>
                            <span className="eventBottomDetailData">
                              ({participant.profile.gender}{participant.profile.nationality && `, ${participant.profile.nationality}`})<br/>
                              {moment(participant.profile.birthDate).format(
                                'D MMMM YYYY'
                              )}<br/>
                              {participant.profile.email}{' '}<br/>
                              (<Icon type="phone" /> {participant.profile.telephone})
                            </span>
                          </div>
                          {participant.profile.nationalId && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'National ID / Passport ID', zh: 'National ID / Passport ID', th: 'เลขประจำตัวประชาชน' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.nationalId}
                            </span>
                          </div>}
                          {participant.profile.street && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Address', zh: 'Address', th: 'ที่อยู่' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.street}
                            </span>
                          </div>}
                          {participant.profile.locality && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Locality', zh: 'Locality', th: 'ตำบล/แขวง' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.locality}
                            </span>
                          </div>}
                          {participant.profile.city && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'City', zh: 'City', th: 'อำเภอ/เขต' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.city}
                            </span>
                          </div>}
                          {participant.profile.province && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Province of Residence', zh: 'Province of Residence', th: 'จังหวัดที่พักอาศัย' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.province}
                            </span>
                          </div>}
                          {participant.profile.country && <div className="eventBottomDetailBox">
                            <span className="eventBottomDetailTitle">
                              {{ en: 'Country of Residence', zh: 'Country of Residence', th: 'ประเทศที่พักอาศัย' }[locale]}
                            </span>
                            <span className="eventBottomDetailData">
                              {participant.profile.country}
                            </span>
                          </div>}
                          {taxInvoiceTypeId !== 'none' && (taxInvoiceChoiceEnabled && taxInvoiceType) &&
                            <div>
                              <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Tax Invoice', zh: 'Tax Invoice', th: 'ใบกำกับภาษี' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                {localeGet(taxInvoiceType, '', locale)}
                                </span>
                              </div>
                              {taxInvoiceTypeId !== 'none' && [
                                <div className="eventBottomDetailBox" key="taxId">
                                  <span className="eventBottomDetailTitle">
                                    {{ en: 'Tax ID', zh: 'Tax ID', th: 'หมายเลขประจำตัวผู้เสียภาษี' }[locale]}
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {_get(participant, 'profile.taxInvoice.taxId')}
                                  </span>
                                </div>,
                                <div className="eventBottomDetailBox" key="address">
                                  <span className="eventBottomDetailTitle">
                                    {{ en: 'Address', zh: 'Address', th: 'ที่อยู่' }[locale]}
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {_get(participant, 'profile.taxInvoice.address')}
                                  </span>
                                </div>
                              ]}
                            </div>
                          }
                          {receiptTypeId !== 'none' && (receiptChoiceEnabled && receiptType) &&
                            <div>
                              <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Tax Invoice', zh: 'Tax Invoice', th: 'ใบกำกับภาษี' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                {localeGet(receiptType, '', locale)}
                                </span>
                              </div>
                              {receiptTypeId !== 'none' && [
                                <div className="eventBottomDetailBox" key="taxId">
                                  <span className="eventBottomDetailTitle">
                                    {{ en: 'Tax ID', zh: 'Tax ID', th: 'หมายเลขประจำตัวผู้เสียภาษี' }[locale]}
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {_get(participant, 'profile.receipt.taxId')}
                                  </span>
                                </div>,
                                <div className="eventBottomDetailBox" key="address">
                                  <span className="eventBottomDetailTitle">
                                    {{ en: 'Address', zh: 'Address', th: 'ที่อยู่' }[locale]}
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {_get(participant, 'profile.receipt.address')}
                                  </span>
                                </div>
                              ]}
                            </div>
                          }
                          {emergencyContact &&
                            <div>
                              <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Emergency Contact', zh: 'Emergency Contact', th: 'ผู้ติดต่อกรณีฉุกเฉิน' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {emergencyContact.name}
                                </span>
                              </div>
                              <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Emergency Contact Relationship', zh: 'Emergency Contact Relationship', th: 'ความสัมพันธ์ผู้ติดต่อ' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {emergencyContact.relationship}
                                </span>
                              </div>
                              <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Emergency Contact Phone Number', zh: 'Emergency Contact Phone Number', th: 'โทรศัพท์ผู้ติดต่อกรณีฉุกเฉิน' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {emergencyContact.phone}
                                </span>
                              </div>
                            </div>
                          }
                        </Col>
                        <Col xs={23} sm={11}>
                          {participant.tickets.map(ticket => (
                            <div key={ticket._id} >
                              <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {
                                    { en: 'Race', zh: 'Race', th: 'ประเภทการแข่งขัน' }[locale]
                                  }
                                </span>
                                <span className="eventBottomDetailData">
                                  {localeGet(ticket, 'ticketType.name', locale)} <Tag color="blue">{ticket.ticketType.price} THB</Tag>
                                </span>
                              </div>
                              {_get(ticket, 'ticketType.race.ageCategories') && <div className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Category', zh: 'Category', th: 'รุ่นอายุ' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {this.ageCategoryString(
                                    getAgeCategory({
                                      race: ticket.ticketType.race,
                                      birthDate:
                                          participant.profile.birthDate,
                                      gender: participant.profile.gender
                                    })
                                  )}
                                </span>
                              </div>}
                              {!hideNumber && ticket.number && (
                                <div className="eventBottomDetailBox" >
                                  <span className="eventBottomDetailTitle">
                                    {
                                      { en: 'Applicant Number', zh: 'Applicant Number', th: 'เลขที่ผู้สมัคร' }[locale]
                                    }
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {bibNumber(ticket.number, _get(event, 'settings.ticket.numberDigits', 0))}
                                  </span>
                                </div>
                              )}
                              {ticket.reservedNumber && (
                                <div>
                                  <span className="eventBottomDetailTitle">
                                    {
                                      { en: 'BIB Number (VIP)', zh: 'BIB Number (VIP)', th: 'เลขบิบ (VIP)' }[locale]
                                    }
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {bibNumber(ticket.reservedNumber, _get(event, 'settings.ticket.numberDigits', 0))}
                                  </span>
                                </div>
                              )}
                              {ticket.nameOnBib &&
                                <div>
                                  <span className="eventBottomDetailTitle">
                                    {
                                      {
                                        en: 'Name On BIB',
                                        zh: 'Name On BIB',
                                        th: 'ชื่อบนเบอร์วิ่ง'
                                      }[locale]
                                    }
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {ticket.nameOnBib}
                                  </span>
                                </div>
                              }
                              {_sortBy(ticket.options, ['question.order']).map(option => {
                                const items = _get(option, 'question.items', [])
                                const optionValue = {
                                  Open: option.value,
                                  Choice: localeGet(items.find(i => i._id === option.itemId), 'value', locale) || option.itemId,
                                  MultiChoice: items.filter(i => option.itemIds && option.itemIds.includes(i._id)).map(i => localeGet(i, 'value', locale)).join(', ')
                                }[option.question.kind]
                                const valueFormatted = option.question.inputType === 'date' ? moment(optionValue).format('D MMMM YYYY') : optionValue
                                if (option.question.inputType === 'heading') {
                                  return (
                                    <div
                                      key={option._id}
                                      className="eventBottomDetailBox"
                                      style={{ marginTop: '12pt' }}
                                    >
                                      <span className="eventBottomDetailTitle">
                                        [{localeGet(option, 'question.name', locale)}]
                                    </span>
                                    </div>
                                  )
                                }
                                if (_get(option, 'question.inputType') === 'shirtTypes') {
                                  return (
                                    <div
                                      key={option._id}
                                      className="eventBottomDetailBox"
                                    >
                                      <span className="eventBottomDetailTitle">
                                        {localeGet(option, 'question.name', locale)}
                                      </span>
                                      <span className="eventBottomDetailData">
                                        {localeGet(event.shirtTypes.find(st => st._id === option.shirtTypeId), 'name', locale)}&nbsp;
                                        {localeGet(event.shirts.find(s => s._id === option.shirtId), 'name', locale)}
                                      </span>
                                    </div>
                                  )
                                }
                                if (!valueFormatted) {
                                  return <div key={option._id} />
                                }
                                const condition = _get(option, 'question.condition')
                                if (_get(condition, 'questionId')) {
                                  const questions = _get(ticket, 'ticketType.questions')
                                  const condQuestionIndex = questions.findIndex(q => q._id === condition.questionId)
                                  const condQuestion = questions[condQuestionIndex]
                                  const condOption = _get(ticket, 'options', []).find(o => `${o.questionId}` === `${condQuestion._id}`)
                                  const condOptionField = {
                                    Open: 'value',
                                    Choice: 'itemId',
                                    MultiChoice: 'itemIds'
                                  }[condQuestion.kind]
                                  const value = _get(condOption, `${condOptionField}`)
                                  if (!compare(value, condition.operator, condition.value)) {
                                    return <div key={option._id} />
                                  }
                                }
                                return (
                                  <div
                                    key={option._id}
                                    className="eventBottomDetailBox"
                                  >
                                    <span className="eventBottomDetailTitle">
                                      {localeGet(option, 'question.name', locale)}
                                    </span>
                                    <span className="eventBottomDetailData">
                                      {valueFormatted}
                                    </span>
                                  </div>
                                )
                              })}
                              {event.shirts.length > 0 && ticket.shirtId &&
                              <div key="shirt" className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Shirt', zh: 'Shirt', th: 'เสื้อ' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {localeGet(event.shirtTypes.find(st => st._id === ticket.shirtTypeId), 'name', locale)}&nbsp;
                                  {localeGet(event.shirts.find(s => s._id === ticket.shirtId), 'name', locale)}
                                </span>
                              </div>
                              }
                              {event.finisherShirts && event.finisherShirts.length > 0 && ticket.finisherShirtId &&
                              <div key="finisherShirt" className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Finisher Shirt', zh: 'Finisher Shirt', th: 'เสื้อ finisher' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {event.finisherShirtTypes && localeGet(event.finisherShirtTypes.find(st => st._id === ticket.finisherShirtTypeId), 'name', locale)}&nbsp;
                                  {event.finisherShirts && localeGet(event.finisherShirts.find(s => s._id === ticket.finisherShirtId), 'name', locale)}
                                </span>
                              </div>
                              }
                            </div>
                          ))}
                        </Col>
                      </Row>
                    })}
                  </div>
                  <div className={`alignCenter`} style={{margin: '12px 0'}}>
                    {(!registrationType.maxParticipants || participants.length < registrationType.maxParticipants) && ['blank', 'draft'].includes(status) &&
                      <Link to={`/reg/${id}/preview?pId=new`}>
                        <Button icon="user-add" className={`create ${participants.length < registrationType.minParticipants ? 'animationHighlighting' : ''}`}>
                          { participants.length === 0 &&
                            <FormattedMessage id="app.regisRaceForOne" defaultMessage="Registration" />
                          }
                          { participants.length > 0 &&
                            <FormattedMessage id="app.addParticipant" defaultMessage="Add Participant" />
                          }
                        </Button>
                      </Link>
                    }
                  </div>
                </Col>
              </Row>
              <div>
                {event.crossProductCount > 0 &&
                  <div className="orderedItemsPreview dividedBox">
                    <h1><FormattedMessage id="app.extraItems" /></h1>
                    {participants.length === 0 && <div style={{color: 'red'}}>
                      <FormattedMessage id="app.warning.requireParticipantsInfo"/>
                    </div>}
                    <ProductCrossSale
                      registrationId={registration._id}
                      onAddOrderItem={this.handleAddOrderItem}/>
                    {registration.orderItems.length > 0 &&
                      <OrderItemsCart
                        event={event}
                        orderItems={registration.orderItems}
                        submitting={this.state.submitting}
                        locale={locale}
                        handleRemoveOrderItem={this.handleRemoveOrderItem} />}
                  </div>}
              </div>
              <div className="dividedBox bigFont">
                {couponCodes && couponCodes.length > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
                  Code: {couponCodes.map(cc => cc.code).join(', ')}
                </div>}
                <div style={{ padding: '8px', textAlign: 'right' }}>
                  ค่าสมัคร: <FormattedNumber value={total - (systemFee * ticketCount)} /> บาท
                </div>
                {discountedItemsAmount > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
                  ค่าสินค้าเพิ่มเติม: <FormattedNumber value={discountedItemsAmount} /> บาท
                </div>}
                {systemFee > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
                  ค่าบริการ: +<FormattedNumber value={systemFee * ticketCount} /> บาท
                </div>}
                {discount > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
                  ส่วนลด: - <FormattedNumber value={discount} /> บาท
                </div>}
                {participants.length > 0 && deliveryPrice > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
                  ค่าจัดส่ง: + <FormattedNumber value={deliveryPrice} /> บาท
                </div>}
                <div style={{ padding: '8px', textAlign: 'right' }} className="totalPrice">
                  รวมทั้งสิ้น: <FormattedNumber value={participants.length > 0 ? discounted + discountedItemsAmount : 0} /> บาท
                </div>
              </div>
              <div className="dividedBox">
                {isPreRegister &&
                  (lottoEnabled
                    ? <div style={{ padding: '8px', textAlign: 'left', whiteSpace: 'pre-line' }}>
                      <div>
                        <Link to="/dashboard" key="done">
                          {{
                            en: 'Done',
                            zh: 'Done',
                            th: 'เสร็จสิ้น'
                          }[locale]}
                        </Link>
                      </div>
                      {_get(lottoMessage, locale)}
                    </div>
                    : <div style={{ padding: '8px', whiteSpace: 'pre-line' }}>
                      {{
                        en: `1. Pre-filled registration is just to filling in the runner’s information in advance. Not an application 
                             2. You must log-in to the registration system again to click “PAY” (=summit). System open for application on ${moment(_get(currentPeriod, 'start')).format('Do MMMM YYYY HH:mm')} and will be closed until it is full.
                             3. Pre-filled registration, the system will not send any response email. You can check your applicant information in the menu “Application history”.
                             4. You can close this window or click on the menu.`,
                        zh: `1. Pre-filled registration is just to filling in the runner’s information in advance. Not an application 
                             2. You must log-in to the registration system again to click “PAY” (=summit). System open for application on ${moment(_get(currentPeriod, 'start')).format('Do MMMM YYYY HH:mm')} and will be closed until it is full.
                             3. Pre-filled registration, the system will not send any response email. You can check your applicant information in the menu “Application history”.
                             4. You can close this window or click on the menu.`,
                        // th: `กรุณากลับมากด ชำระเงิน อีกครั้งในวันที่ ${moment(_get(currentPeriod, 'start')).format('Do MMMM YYYY HH:mm')} เป็นต้นไป การกรอกข้อมูลล่วงหน้า`
                        th: `1. ขั้นตอนนี้เป็นเพียงการกรอกข้อมูลล่วงหน้า ยังไม่ใช่การสมัคร 
                             2. Open system for recruitment ${moment(_get(currentPeriod, 'start')).format('Do MMMM YYYY HH:mm')} ปิดรับสมัครทันทีที่มีผู้สมัครครบเต็มจำนวน
                             3. การกรอกข้อมูลล่วงหน้าจะไม่มีอีเมลยืนยัน ท่านสามารถตรวจสอบข้อมูลได้ที่เมนู ประวัติการสมัคร 
                             4. หากไม่แก้ไขแล้ว ท่านสามารถปิดหน้าต่างนี้ หรือ กดที่เมนู`,
                      }[locale]} <Link to="/dashboard" key="done">
                        {{
                          en: 'Done',
                          zh: 'Done',
                          th: 'เสร็จสิ้น'
                        }[locale]}
                      </Link>
                    </div>
                  )
                }
                {(acceptCondition && acceptCondition.enabled) && <div style={{ padding: '8px' }}>
                  {<Checkbox onChange={this.handleAccept}
                    checked={this.state.accepted}
                    style={{ fontSize: '15px', fontFamily: 'kanit', whiteSpace: 'pre-line' }}
                    className={!this.state.accepted ? `modCheckBox` : `modCheckedBox`}>
                    {localeGet(acceptCondition, 'message', locale)}
                  </Checkbox>}
                </div>}
                {regIncomplete && $regIncompleteNotice}
                <div style={{ padding: '8px', textAlign: 'right' }}>
                  {$nextAction}
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      {!!pdId && pdId !== 'select' &&
        <OrderItemModal
          event={event}
          registrationId={registration._id}
          masterId={registration._id}
          masterType="Registration"
          productId={pdId}
          onAddOrderItem={this.handleAddOrderItem }
        />
      }
      {event && registration && pId &&
        <ParticipantEditModal visible={editingParticipant}
          event={event} registration={registration}
          participantId={pId}/>
      }
      {deliverOneAddressEnabled && dAddr === 'select' && event && registration &&
        <DeliveryAddressModal
          visible={selectDAddrVisible}
          event={event}
          registration={registration}
          dAddrId={dAddrId}
          customMessage={_get(selectedDeliveryOption, `customMessage[${locale}]`, '')}
        />
      }
    </div>
  }
}

export default RegistrationPreview



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/RegistrationPreview/RegistrationPreview.js